import _ from "lodash";
import { getStorageItem } from "@/utils/auth";
import { dloInfoPos } from "@/utils/pos";
import { defaultPos } from "../V2/pos/utils/pos";

export function clonePosData(orderId, datas) {
  const itemId = orderId;
  const listItemDrafts = getStorageItem("SELL");
  let itemcheckBoxTaxOrder =
    listItemDrafts != null || listItemDrafts != undefined
      ? listItemDrafts.orders.filter((e) => {
          if (e.id === itemId) return e;
        })
      : [];
  const checkBoxTaxOrder = itemcheckBoxTaxOrder.length > 0 ? itemcheckBoxTaxOrder[0].checkBoxTaxOrder : false;
  const discountOrder = itemcheckBoxTaxOrder.length > 0 ? itemcheckBoxTaxOrder[0].discountOrder : 0;
  const ortherService = itemcheckBoxTaxOrder.length > 0 ? itemcheckBoxTaxOrder[0].ortherService : 0;
  const totalOrder = itemcheckBoxTaxOrder.length > 0 ? itemcheckBoxTaxOrder[0].totalOrder : 0;
  const payments = itemcheckBoxTaxOrder.length > 0 ? itemcheckBoxTaxOrder[0].payments : 0;
  const noteOrder = itemcheckBoxTaxOrder.length > 0 ? itemcheckBoxTaxOrder[0].noteOrder : "";

  if (datas.partyB.resId) {
    datas.partyB.textShow = datas.partyB.displayName + " - " + datas.partyB.phoneNo;
  }
  const newDataRaw = _.cloneDeep(defaultPos);
  const data = {
    ...newDataRaw,
    listItemCart: datas.lineItem.map((e) => {
      let discount_perThousand = e.discount[0].perThousand;
      let discount_amount = e.discount[0].amount;
      let typeDiscount = "%";
      let discount = 0;

      if (discount_perThousand > 0) {
        discount = discount_perThousand / 10;
        typeDiscount = "%";
      }
      if (discount_amount > 0) {
        discount = Math.floor(discount_amount);
        typeDiscount = "đ";
      }

      let tax_perThousand = e.tax.length > 0 ? e.tax[0].perThousand / 10 : 0;

      //Serial/Imei
      if (e.lineItemOtherInfo.seriesNo && e.lineItemOtherInfo.seriesNo.length > 0) {
        const seriesNo = e.lineItemOtherInfo.seriesNo;
        e.seriesNoTmp = seriesNo;
        e.useImeiAndSerial = true;
        e.getSeri = [];
        seriesNo.map((_e) => {
          e.getSeri.push({ id: _e, text: _e });
        });
      }

      return {
        ...e,
        discount: discount,
        images: e.itemInstance.images,
        tax: tax_perThousand,
        itemInstance: {
          ...e.itemInstance,
          note: "",
        },
        typeDiscount: typeDiscount,
        amount: Math.round(e.amount/e.quantity)
      };
    }),
    partyB: {
      ...newDataRaw.partyB,
      ...datas.partyB,
    },
    totalAmountCart: datas.lineItemAgg.netSubTotal,
    taxOrder: datas.lineItemFinalizing.addedFee[0].extraData.value ? datas.lineItemFinalizing.addedFee[0].extraData.value : 0,
    discountOrder: discountOrder > 0 ? discountOrder : 0 - datas.lineItemFinalizing.addedFee[1].amount,
    ortherService: ortherService > 0 ? ortherService : datas.lineItemFinalizing.addedFee[2].amount,
    totalOrder: totalOrder > 0 ? floor(totalOrder) : floor(datas.lineItemFinalizing.finalAmount),
    payments: totalOrder > 0 ? floor(totalOrder) : floor(datas.lineItemFinalizing.finalAmount),
    noteOrder: noteOrder !== "" ? noteOrder : datas.note,
    checkBoxTaxOrder: datas.lineItemFinalizing.addedFee[0].extraData.checkBox ? datas.lineItemFinalizing.addedFee[0].extraData.checkBox : checkBoxTaxOrder,
    id: datas.id,
    dloInfo: _.cloneDeep(dloInfoPos),
    selecTypeInput: "đ",
    // đã thanh toán
    paymentInfos: []
  };
  // đã thanh toán
  const paymentInfosList = []
  datas.outcomes.map(outcomeItem => {
    if (outcomeItem.cat === "NSH_PAYMENT" && outcomeItem.params.amount > 0 && outcomeItem.params.status === "SUCCESS") {
      if(casePayment[outcomeItem.note]) {
        const item = {...casePayment[outcomeItem.note]}
        item.amount = +outcomeItem.params.amount
        paymentInfosList.push(item)
      }
    }
  })
  if (paymentInfosList.length > 0) {
    data.paymentInfos = paymentInfosList;
  }
  console.log("tiep tuc ban::::::", {datas, data, paymentInfosList})
  // console.log(datas)
  // console.log(itemcheckBoxTaxOrder)
  return data;
}

function divideThousound(num) {
  return Math.round(+num/1000)
}

function floor(num) {
  return Math.floor(num)
}

// paymentInfos.push()

const casePayment = {
  "CASH" : {
    paymentMethod: "CASH",
    paymentGateway: "CASH",
    note: "Tiền mặt",
    imgUrl: require("@/assets/images/Payment_Cash.svg"),
    active: false,
    amount: 0,
    status: "SUCCESS",
  },
  "BANK_TRANSFER": {
    paymentMethod: "BANK_TRANSFER",
    paymentGateway: "BANK",
    note: "Chuyển khoản",
    imgUrl: require("@/assets/images/Payment_Transfer.svg"),
    active: false,
    amount: 0,
    status: "SUCCESS",
  },
  "SWIPE": {
    paymentMethod: "SWIPE",
    paymentGateway: "MPOS",
    note: "Mpos",
    imgUrl: require("@/assets/images/Payment_Mpos.svg"),
    active: false,
    amount: 0,
    status: "SUCCESS",
  },
  "ONLINE": {
    paymentMethod: "ONLINE",
    paymentGateway: "OTHER",
    note: "Quẹt thẻ",
    imgUrl: require("@/assets/images/credit.svg"),
    active: false,
    amount: 0,
    status: "SUCCESS",
  }
}